const getStyles = () => {
  return {
    // Section Wrapper
    section: {
      padding: '80px 0',
      background: 'linear-gradient(180deg, #f9fafb 0%, #ffffff 100%)'
    },

    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      '@media (min-width: 640px)': { padding: '0 24px' }
    },

    // Header Section
    header: {
      textAlign: 'center',
      marginBottom: '64px',
      animation: 'fadeIn 0.8s ease-out'
    },

    title: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      color: '#1a202c',
      marginBottom: '16px',
      '@media (min-width: 768px)': { fontSize: '3rem' }
    },

    subtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '600px',
      margin: '0 auto'
    },

    // Accordion Styles
    accordionContainer: {
      maxWidth: '800px',
      margin: '0 auto',
      animation: 'fadeIn 0.8s ease-out'
    },

    accordionItem: {
      marginBottom: '16px',
      border: '1px solid #e2e8f0',
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      overflow: 'hidden',
      '&:hover': {
        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)'
      },
      animation: 'fadeIn 0.8s ease-out'
    },

    accordionSummary: {
      fontWeight: 600,
      color: '#1a202c',
      padding: '20px 24px',
      '&:hover': {
        color: '#4f46e5'
      }
    },

    accordionDetails: {
      backgroundColor: '#f9fafb',
      borderTop: '1px solid #e5e7eb',
      padding: '16px 24px'
    },

    question: {
      fontSize: '1.125rem',
      fontWeight: '600'
    },

    answer: {
      color: '#6b7280',
      lineHeight: 1.7,
      fontSize: '1rem'
    },

    expandIcon: {
      color: '#4f46e5',
      transition: 'transform 0.3s ease',
      '&.Mui-expanded': {
        transform: 'rotate(180deg)'
      }
    },

    // Animations
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    }
  };
};

export default getStyles;
